module.exports = __webpack_public_path__ + "img/iconBg3.b0d70ec2.png";